import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a0d] py-12 px-4" data-id="element-313">
      <div className="max-w-5xl mx-auto" data-id="element-314">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-12 text-center" data-id="element-315">
          <div data-id="element-316">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-317">
              +800
            </div>
            <div className="text-[#39FF14] text-sm font-semibold mt-1" data-id="element-318">
              docentes confían
            </div>
          </div>
          <div data-id="element-319">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-320">6</div>
            <div className="text-[#39FF14] text-sm font-semibold mt-1" data-id="element-321">
              Tomos listos
            </div>
          </div>
          <div data-id="element-322">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-323">6</div>
            <div className="text-[#39FF14] text-sm font-semibold mt-1" data-id="element-324">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-325">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-326">
              4.9/5
            </div>
            <div className="text-[#39FF14] text-sm font-semibold mt-1" data-id="element-327">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-328">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-329">🇦🇷</div>
            <div className="text-[#39FF14] text-sm font-semibold mt-1" data-id="element-330">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-331">
          <div className="flex items-start gap-3 bg-black/40 border border-[#39FF14]/20 rounded-xl p-4" data-id="element-332">
            <div className="w-10 h-10 rounded-full bg-[#39FF14]/20 flex items-center justify-center text-[#39FF14] font-black text-sm flex-shrink-0" data-id="element-333">
              MG
            </div>
            <div data-id="element-334">
              <div className="text-[#39FF14] text-xs mb-1" data-id="element-335">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-336">
                "Organicé todo el año de Português en una tarde. Nunca más
                llegué sin material al aula. Mis alumnos no pueden creer que
                aprendan tanto en cada clase."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-337">
                — Mariela G., Córdoba | Docente de Português Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#39FF14]/20 rounded-xl p-4" data-id="element-338">
            <div className="w-10 h-10 rounded-full bg-[#39FF14]/20 flex items-center justify-center text-[#39FF14] font-black text-sm flex-shrink-0" data-id="element-339">
              LP
            </div>
            <div data-id="element-340">
              <div className="text-[#39FF14] text-xs mb-1" data-id="element-341">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-342">
                "Las actividades están perfectamente pensadas para el alumno
                argentino. El solucionario me ahorra horas cada semana y los
                falsos amigos son el hit de la clase."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-343">
                — Laura P., Rosario | Docente de Português 1º a 4º año
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#39FF14]/20 rounded-xl p-4" data-id="element-344">
            <div className="w-10 h-10 rounded-full bg-[#39FF14]/20 flex items-center justify-center text-[#39FF14] font-black text-sm flex-shrink-0" data-id="element-345">
              RM
            </div>
            <div data-id="element-346">
              <div className="text-[#39FF14] text-xs mb-1" data-id="element-347">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-348">
                "Nunca más llegué sin material. Mis clases de 5º año sobre
                cultura brasileña por fin enganchan de verdad. El tomo de
                literatura brasileña es increíble."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-349">
                — Roberto M., Buenos Aires | Docente de Português Secundaria
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}